export const QUALITY_OPTIONS = [
  { value: "little", label: "Peu de sauce", short: "peu" },
  { value: "normal", label: "Normal", short: "normal" },
  { value: "alot", label: "Beaucoup de sauce", short: "bcp" },
];

export const getQualityShortLabel = (value) => {
  const option = QUALITY_OPTIONS.find((q) => q.value === value);
  return option ? option.short : null;
};
